import type { TextFieldProps } from './TextField';
import { TextField } from './TextField';

export type NumberFieldProps = Omit<TextFieldProps, 'type'>;

export const NumberField = (props: NumberFieldProps) => (
  <TextField type="number" {...props} />
);
